module.exports = __webpack_public_path__ + "img/INTERIOR-FRONX-BOOSTERGREEN-4.9c982136.jpg";